module.exports = __webpack_public_path__ + "img/mugshot-10.3f250aaf.jpg";